import { render } from "./FilterNew.vue?vue&type=template&id=36273566"
import script from "./FilterNew.vue?vue&type=script&lang=js"
export * from "./FilterNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__